import { forRails } from 'components/for-rails'
import { OrgDescriptionNotice } from 'components/org-description-notice'
import { OrgPublicNotice } from 'components/org-public-notice'
import { SettingsSideNav } from 'components/settings-side-nav'
import { SettingsBreadcrumbs } from 'components/settings-breadcrumbs'
import { SettingsTitle } from 'components/settings-title'
import { TeamStatusTable } from '../src/components/team-status-table'
import { registerComponents } from '../src/utils/react/registry'
import { TeamMembersPage } from 'components/team-members-page'
import { TeamOpenRolesSection } from 'components/team-open-roles-section'
import { TeamEditorsPage } from 'components/team-editors-page'
import { CustomRatingScalesPage } from '../src/pages/custom-rating-scales'
import { CheckinCyclesPage } from '../src/pages/checkin-cycles'
import { HealthAuditSettingsPage } from 'components/health-audit-settings-page'

registerComponents({
  OrgDescriptionNotice: forRails(OrgDescriptionNotice),
  OrgPublicNotice: forRails(OrgPublicNotice),
  SettingsSideNav: forRails(SettingsSideNav),
  TeamStatusTable: forRails(TeamStatusTable),
  SettingsTitle: forRails(SettingsTitle),
  SettingsBreadcrumbs: forRails(SettingsBreadcrumbs),
  TeamMembersPage: forRails(TeamMembersPage),
  TeamEditorsPage: forRails(TeamEditorsPage),
  TeamOpenRolesSection: forRails(TeamOpenRolesSection),
  CustomRatingScalesPage: forRails(CustomRatingScalesPage),
  CheckinCyclesPage: forRails(CheckinCyclesPage),
  HealthAuditSettingsPage: forRails(HealthAuditSettingsPage),
})
